import sortBy from 'lodash/sortBy'

// Mirrors V9 `ORDER BY priority ASC, LOWER(name)` so items, observations, and
// any other collection ordered this way line up with the PDF/V9 templates.
const sortByPriorityName = (collection) =>
  sortBy(collection, ['priority', (x) => (x.name || '').toLowerCase()])

export default async ({ commit }, { report, reportView }) => {
  const attributify = (collection) =>
    collection.map((attributes) => ({ id: attributes.id, attributes }))

  // Data mapping
  report.sections.map((section) => {
    section.items.map((item) => {
      item.observations.map((observation) => {
        observation.photos.map((photo) => {
          if (photo.video_url) {
            photo.video = true
          }
          if (!photo.video_url) {
            photo.image = photo.edited_image_url || photo.original_image_url
          }
          photo.report_section_id = section.id
          photo.report_item_id = item.id
          photo.observation_id = observation.id
        })
        observation.report_section_id = section.id
        observation.report_item_id = item.id
      })
      item.report_section_id = section.id
    })
  })

  const sections = report.sections
  // PDF/V9 templates iterate items in priority+name order, then iterate each
  // item's observations. Group the flattened observations the same way so the
  // Information / Limitations tabs do not interleave items.
  const items = sortByPriorityName(sections.flatMap((s) => s.items))
  const observations = items.flatMap((item) => {
    item.observations.forEach((observation) => {
      observation.observation_photos = attributify(observation.photos)
    })
    return sortByPriorityName(item.observations).map(
      // eslint-disable-next-line camelcase
      ({ report_item, ...observation }) => observation
    )
  })
  commit('setValue', {
    key: 'report',
    value: {
      ...report,
      firestore: true,
      attributes: {
        ...report,
        image_url: report.image,
      },
    },
  })

  const defects = attributify(
    observations.filter((observation) => observation.comment_type === 'defect')
  )
  const defectsBySection = defects.reduce((acc, curr) => {
    const section = sections.find(
      ({ id }) => id === curr.attributes.report_section_id
    )
    if (!acc[section.name]) {
      acc[section.name] = {
        defects: [],
      }
    }

    acc[section.name].defects.push(curr)
    return acc
  }, {})

  commit('setValue', { key: 'sections', value: attributify(report.sections) })
  commit('setValue', { key: 'items', value: attributify(items) })
  commit('setValue', { key: 'observations', value: attributify(observations) })
  commit('setValue', {
    key: 'defects',
    value: defects,
  })
  commit('setValue', {
    key: 'defectsBySection',
    value: defectsBySection,
  })
  commit('setValue', {
    key: 'inspection',
    value: {
      attributes: {
        property_address: report.inspection.address1,
        property_address_2: report.inspection.address2,
      },
    },
  })
  commit('setValue', {
    key: 'inspector',
    value: {
      attributes: {
        property_address: report.inspection.address1,
        property_address_2: report.inspection.address2,
      },
    },
  })
  if (reportView) {
    commit('setValue', { key: 'reportView', value: reportView })
  }
  if (report.inspectors && report.inspectors.length) {
    commit('setValue', { key: 'reportAssignments', value: report.inspectors })
  }
  if (report.company) {
    commit('setValue', {
      key: 'company',
      value: {
        id: report.company.id,
        attributes: {
          ...report.company,
          image_url: report.company.image,
          settings: report.company.settings || {},
        },
      },
    })
  }
  return true
}
